import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import { useNotify, useRedirect } from "ra-core";

import LayoutContainer from "../components/LayoutContainer";
import LeftGridEdit from "../components/LeftGridEdit";
import { Loading } from "react-admin";
import RightGridEdit from "../components/RightGridEdit";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import StatusInput from "../components/StatusInput";
import TextInputRA from "../components/TextInputRA";
import TierBenefitInput from "../components/TierBenefitInput";
import TierConditionFixedField from "../components/TierConditionFixedField";
import TierEditValidation from "../../../ValidationRules/TierEditValidationRule";
import { isAdminUser } from "../../../hooks/useCheckPermission";
import useCheckPermissionHook from "../../../hooks/useCheckPermissionHook";

const useStyles = makeStyles((theme) => ({
  row: {
    display: "grid",
    gridTemplateColumns: "145px 150px 1fr",
    gridGap: 5,
    width: "100%",
    alignItems: "center",
    // marginLeft: 20,
  },
  height100: {
    height: "100%",
    marginTop: 0,
  },
}));
const transform = (data) => {
  //alert(JSON.stringify(data));
  //return null;

  if (!data.conditions[0].condition_id) {
    data.conditions[0].condition_id = data.tier_condition_id;
  }
  // data.conditions[0].condition_id = data.condition_id;
  return {
    ...data,
    level: Number(data.level),
  };
};
const TierEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const classes = useStyles();

  // const allow = isAdminUser();
  const { loading, allow } = useCheckPermissionHook({
    code: "Page.Merchant.Management.Tier",
    write: true,
  });
  if (loading) return <Loading />;
  const onSuccess = () => {
    notify("Edit successfully"); // default message is 'ra.notification.updated'
    redirect("list", props.basePath);
  };
  const onFailure = (error) => {
    if (error.code === 123) {
      notify(
        "Could not save changes: concurrent edition in progress",
        "warning"
      );
    } else {
      notify("ra.notification.http_error", "warning");
    }
    redirect("list", props.basePath);
  };

  return (
    <LayoutContainer>
      <Grid container style={{ height: "100%" }}>
        <LeftGridEdit
          transform={transform}
          onSuccess={onSuccess}
          onFailure={onFailure}
          {...props}
          validate={TierEditValidation}
          disabled={!allow}
        >
          <SfBreadcrumbs path="Management/Tiers/Edit" />
          <Box style={{ margin: 50 }}>
            <TextInputRA label="Tier name" source="name" />
            <TextInputRA label="Level" source="level" type="number" />
            <TextInputRA
              label="Money Required"
              source="conditions[0].value"
              type="number"
            />
            <TierConditionFixedField />
            <Box className={classes.row}>
              <Typography style={{ fontSize: 16 }}>Tier Benefit</Typography>
              <TierBenefitInput />
              <TextInputRA
                isDouble
                label=""
                source="privileges[0].item.value"
                type="number"
                noLabel
              />
            </Box>
            <StatusInput />
          </Box>
        </LeftGridEdit>
        <RightGridEdit resource="member-tiers" {...props} />
      </Grid>
    </LayoutContainer>
  );
};

export default TierEdit;
